import { SET_CURRENT_LANGUAGE } from 'redux/types'
import initialState from 'redux/initialState'

export default function languageReducer(state = initialState.language, action) {
  let newState = '';
  switch (action.type) {
      case SET_CURRENT_LANGUAGE:
        return newState = action.payload;
    default:
      return state
  }
}